import React, { useState, useRef } from 'react';
import { Button, Col, Switch, DatePicker, Drawer, Form, Input, Row, Select, InputNumber, Space, message, Modal } from 'antd';
import {insertWithRelation, getById} from '../../../../apis/AcomuladoApi';
import {getList as getAllConcepts} from '../../../../apis/ConceptoApi';
const { Option } = Select;
const AddAcomulado = ({title, conceptoId, id, open, finish}) => {
    const [ form ] = Form.useForm()
    const [ID, setID] = useState(id);
    const [concepts, setConcepts] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [initialValues, setInitialValues] = useState(null);

    const handleOk = async () => {

        try {
            const values = await form.validateFields();
            if(!values) return;
        } catch (errorInfo) {
            console.log('Failed:', errorInfo);
            return;
        }

        const fields = form.getFieldsValue()
        var defaultValue = {
            concepto_id: conceptoId,
        }
        const payload = {
            ...fields,
            ...defaultValue
        }
        const response = await insertWithRelation(payload);
        if(response.ok){
            message.success('Se guardo correctamente el parametro!');
            setShowModal(false);
            finish(true);
        }
    }

    const onClose = ()=>{
        setShowModal(false);
        finish(false);
    }

    React.useEffect(() => {
        setShowModal(open);
    }, [open]);

    React.useEffect(() => {
        setID(id);
    }, [id]);

    const effectRan = useRef(false);
    React.useEffect(() => {
      if (!effectRan.current) {
        (async ()=>{
            await getConcepts();
            if(ID > 0){
                await refreshData();
            }else{
                setInitialValues({
                    concepto_id: conceptoId,
                    concepto_parent_id: null,
                });
            }
        })()
      }
    
      return () => effectRan.current = true;
    }, [ID]);

    const refreshData = async ()=> {
        debugger;
        if(ID > 0){
            const response = await getById(ID);
            if(response.ok){
              let item = response.payload;
              setInitialValues(item);
            }
        }else{
            setInitialValues({
                acomulado_id: conceptoId,
            });
        }
    }
    
    const getConcepts = async ()=>{
        const response = await getAllConcepts();
        if(response.ok){
          let conceptsList = response.payload;
          setConcepts(conceptsList);
        }
    }

  return (
      <Drawer
        title={title}
        width={720}
        placement={"right"}
        onClose={onClose}
        open={open}
        closable={true}
        height={'80%'}
        onFinish={handleOk}
        styles={{
          body: {
            paddingBottom: 80,
          },
        }}
        extra={[
            <Space>
                <Button onClick={onClose}>Cancelar</Button>
                {
                    ID > 0 ? null: 
                    <Button onClick={handleOk} type="primary">
                        Guardar
                    </Button>
                }
            </Space>
        ]}
      >
        {
            initialValues && 
            <Form layout="vertical" form={form} hideRequiredMark onFinish={handleOk} initialValues={initialValues}>
                <Row gutter={16}>
                    {
                        concepts && concepts.length > 0 && 
                        <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                            <Form.Item
                                name="concepto_parent_id"
                                label="Concepto"
                                rules={[
                                {
                                    required: true,
                                    message: 'Por favor selecciona el concepto',
                                },
                                ]}
                            >
                                <Select placeholder="Por favor selecciona el concepto" 
                                    showSearch
                                    filterOption={(input, option) =>
                                        (option?.children ?? '').toLowerCase().includes(input.toLowerCase())
                                    }>
                                    {
                                        concepts.map((item)=><Option value={item.value}>{item.text}</Option>)
                                    }
                                </Select>
                            </Form.Item>
                        </Col>
                    }
                </Row>
            </Form>
        }
      </Drawer>
  );
};
export default AddAcomulado;